import React, { useState, useEffect, useRef } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import "./PackageForm.css"

const PackageExclude = ({ packageId }) => {
  const initialFieldValues = {
    packageExcludeId: "00000000-0000-0000-0000-000000000000",
    packageId: packageId || "00000000-0000-0000-0000-000000000000",
    userId: "00000000-0000-0000-0000-000000000000",
    description: "",
  };
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [data, setData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);

  const GetData = async () => {
    const res = await apiService.get(
      `${config.GETEXCLUDEBYPACKAGEID}/${packageId}`
    );
    console.log(res);
    setLists(res.data);
    setData(res.data);
  };

  const showEditDetails = (data) => {
    setRecordForEdit(data);
  };

  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGEEXCLUDE, itemToDelete);
        await GetData();
      } catch (error) {
      }
      handleCloseDeleteModal();
    }
  };

  const validate = () => {
    let temp = {};
    temp.description = values.description === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        packageExcludeId: values.packageExcludeId,
        packageId: packageId,
        description: values.description,
        userId: user?.id,
      };
      console.log("Submitting form data:", formData);
      try {
        const isNew =
          formData.packageExcludeId === "00000000-0000-0000-0000-000000000000";

        if (isNew) {
          await apiService.create(config.CREATEPACKAGEEXCLUDE, formData);
        } else {
          await apiService.update(config.UPDATEPACKAGEEXCLUDE, formData);
        }
        await GetData();
        resetForm();
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setBtnLoading(false);
    setRecordForEdit(null);
    setErrors({});
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
 useEffect(() => {
    if (packageId) {
      GetData();
    }
  }, [packageId]);
   return (
    <div className="PackageInclude-wrapper">
      <div className="PackageInclude-card">
        <div className="PackageInclude-header">
          <h4 className="header-title">Exclusions</h4>
          <p className="header-subtitle">Add or edit package exclusions below</p>
        </div>

        <div className="PackageInclude-list">
          {lists.length > 0 ? (
            lists.map((item) => (
              <div
                key={item.packageExcludeId}
                className="PackageInclude-list-item"
              >
                <i className="ri-close-circle-line item-icon" />

                {recordForEdit?.packageExcludeId === item.packageExcludeId ? (
                  <>
                    <input
                      type="text"
                      name="description"
                      value={values.description}
                      onChange={handleInputChange}
                      className="item-edit-input"
                    />
                    <div className="item-actions">
                      <button
                        className="PackageInclude-action-btn save"
                        onClick={handleSubmit}
                      >
                        <i className="ri-check-line"></i>
                      </button>
                      <button
                        className="PackageInclude-action-btn cancel"
                        onClick={resetForm}
                      >
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                    
                  </>
                ) : (
                  <>
                    <p className="item-description">{item.description}</p>
                    <div className="item-actions">
                      <button
                        className="PackageInclude-action-btn edit"
                        onClick={() => showEditDetails(item)}
                      >
                        <i className="ri-pencil-fill"></i>
                      </button>
                      <button
                        className="PackageInclude-action-btn delete"
                        onClick={() =>
                          handleOpenDeleteModal(item.packageExcludeId)
                        }
                      >
                        <i className="ri-delete-bin-fill"></i>
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <div className="PackageInclude-empty-state">
              <i className="ri-inbox-line empty-icon"></i>
              <h5>No exclusions found</h5>
            </div>
          )}
        </div>

        <div className="PackageInclude-list-item mt-3">
          <i className="ri-add-circle-line item-icon"></i>
          <input
            type="text"
            name="description"
            value={recordForEdit === null ? values.description : ""}
            onChange={handleInputChange}
            placeholder="Add a new exclusion..."
            className="form-control"
          />
          <button className="PackageInclude-action-btn save" onClick={handleSubmit}>
            <i className="ri-check-line"></i>
          </button>
        </div>
      </div>

      <DeleteAlert
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        handleDelete={handleDelete}
      />
    </div>
  );
};

export default PackageExclude;